<template>
  <div class="min-h-screen bg-gray-100">
    <div class="no-print sticky top-0 z-10 flex items-center justify-between bg-gray-900 px-6 py-3 text-white">
      <router-link to="/admin/vouchers" class="text-sm font-semibold text-gray-300 hover:text-white">&larr; Back to Vouchers</router-link>
      <div v-if="voucher" class="flex items-center gap-2">
        <span v-if="shareFeedback" class="text-xs font-medium text-gray-300">{{ shareFeedback }}</span>
        <button
          @click="share"
          :disabled="sharing"
          class="rounded-full border border-gray-600 px-5 py-2 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:opacity-60"
        >
          {{ sharing ? 'Preparing...' : 'Share' }}
        </button>
        <button
          @click="print"
          class="rounded-full bg-amber-500 px-5 py-2 text-sm font-semibold text-white hover:bg-amber-600"
        >
          Print / Save as PDF
        </button>
      </div>
    </div>

    <div v-if="loading" class="py-20 text-center text-gray-400">Loading...</div>
    <div v-else-if="!voucher" class="py-20 text-center text-gray-500">Voucher not found.</div>
    <div v-else class="my-8 px-4">
      <VoucherDocument ref="doc" :voucher="voucher" :view-url="viewUrl" />
    </div>
  </div>
</template>

<script>
import { getItem } from '../../services/dataStore'
import VoucherDocument from '../../components/VoucherDocument.vue'
import { printDocument } from '../../utils/printHelper'
import { shareLinkWithPdf } from '../../utils/shareHelper'
import { generatePdfBlob } from '../../utils/pdfHelper'

export default {
  name: 'VoucherPrint',
  components: { VoucherDocument },
  data() {
    return {
      loading: true,
      voucher: null,
      shareFeedback: '',
      sharing: false
    }
  },
  computed: {
    viewUrl() {
      if (!this.voucher) return ''
      return `${window.location.origin}/voucher/${this.voucher.id}`
    }
  },
  async mounted() {
    this.voucher = await getItem('vouchers', this.$route.params.id)
    this.loading = false
  },
  methods: {
    print() {
      printDocument()
    },
    async share() {
      this.sharing = true
      let pdfBlob = null
      try {
        if (this.$refs.doc) pdfBlob = await generatePdfBlob(this.$refs.doc.$el)
      } catch (e) {
        pdfBlob = null
      }
      const result = await shareLinkWithPdf(this.viewUrl, `Voucher ${this.voucher.voucherNo}`, pdfBlob, `${this.voucher.voucherNo}.pdf`)
      if (result.downloaded) {
        this.shareFeedback = result.copied ? 'PDF downloaded, link copied!' : 'PDF downloaded!'
        setTimeout(() => { this.shareFeedback = '' }, 3500)
      } else if (result.copied) {
        this.shareFeedback = 'Link copied!'
        setTimeout(() => { this.shareFeedback = '' }, 2500)
      }
      this.sharing = false
    }
  }
}
</script>

<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
